import { Link } from "react-router-dom";
import { BTN_FILL, CONTAINER, EYEBROW_LIGHT, LABEL, telHref } from "../tokens";

// Page « Demande envoyée » du moteur "couture_v1" — atteinte par la fenêtre
// de contact partagée (ContactModalProvider) ; le formulaire de la page
// Professionnels & contact, lui, confirme sur place comme le handoff.
// Même vocabulaire que le reste du site : sur-titre espacé, titre Cormorant
// léger, filet, bouton plein sans arrondi.
export default function ContactConfirmationPage({ copy, name, message, email, phone, homeTo }) {
  return (
    <section
      data-testid="contact-confirmation"
      className={`${CONTAINER} px-5 md:px-11 py-16 md:py-24 grid gap-12 md:grid-cols-2 items-start animate-fade-up`}
    >
      <div>
        <div className={EYEBROW_LIGHT}>{copy.eyebrow}</div>
        <h1 className="font-display font-light text-[clamp(30px,4.2vw,50px)] leading-[1.12] text-ink mt-5 [text-wrap:balance]">
          {name ? copy.titleNamed(name) : copy.title}
          {copy.titleAfter}
        </h1>
        <span className="block w-16 h-px bg-ink/25 mt-7 mb-5" aria-hidden="true" />
        <p
          data-testid="contact-confirmation-message"
          className="text-[15px] leading-[1.85] font-light text-graphite max-w-[520px] whitespace-pre-line [text-wrap:pretty]"
        >
          {message}
        </p>
        <Link to={homeTo} data-testid="contact-confirmation-home" className={`${BTN_FILL} mt-8`}>
          {copy.home}
        </Link>
      </div>

      <div className="bg-sand border border-ink/[0.12] p-6 md:p-8">
        <div className={LABEL}>{copy.stepsTitle}</div>
        <ol className="mt-5 grid gap-4">
          {copy.steps.map((step, i) => (
            <li key={step.title} className="flex gap-3.5 items-baseline">
              <span className="font-display text-[22px] text-gold min-w-[28px]">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <div className="font-display text-[20px] leading-[1.3] text-ink">{step.title}</div>
                <div className="text-[13px] leading-[1.75] font-light text-graphite mt-1">{step.text}</div>
              </div>
            </li>
          ))}
        </ol>
        {(email || phone) && (
          <div className="mt-7 pt-5 border-t border-ink/[0.14]">
            <div className={LABEL}>{copy.urgent}</div>
            <div className="mt-3 grid gap-2 text-[14px] font-light text-graphite">
              {email && <a href={`mailto:${email}`} className="text-ink hover:text-ash break-all w-fit">{email}</a>}
              {phone && <a href={telHref(phone)} dir="ltr" className="text-ink hover:text-ash w-fit">{phone}</a>}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
